import { Component, OnInit, inject } from '@angular/core';
import { LiveClassService } from '../shared/core/state/live-class/live-class.service';
import { Router } from '@angular/router';
import { RecordingUploadSession } from '../shared/core/models/upload-session.model';

@Component({
  selector: 'black-past-meetings',
  standalone: false,

  templateUrl: './past-meetings.component.html',
  styleUrl: './past-meetings.component.css',
})
export class PastMeetingsComponent implements OnInit {
  private liveClassService = inject(LiveClassService);
  private router = inject(Router);

  sessionRecordings: RecordingUploadSession[] = [];

  ngOnInit(): void {
    this.fetchAllRecordings();
  }

  fetchAllRecordings() {
    this.liveClassService.fetchAllRecordings().subscribe((res) => {
      this.sessionRecordings = res.map((recording) => {
        return {
          sessionId: recording._id,
          sessionDate: recording.sessionDate,
          sessionName: recording.sessionName,
          liveClass: recording.liveClass,
          resource: recording.resource,
        };
      });
    });
  }

  playVideo(sessionId: string) {
    this.router.navigate(['past-meetings', 'play', sessionId]);
  }
}
